import SeriesManagementIcon from "../../../components/Common/SvgIcons/OrganizeIcons/SeriesManagementIcon";
import { tableColumnTypes } from "../../tableColumnTypes";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import ToggleButton from "../../../components/Common/ToggleButton/ToggleButton";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { addSeriesMgmt } from "./addSeriesMgmt";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import DistributeIcon from "../../../components/Common/SvgIcons/TableIcons/DistributeIcon";
import { FormattedMessage } from "react-intl";

export let seriesManagement = {
  name: <FormattedMessage id="PROGRAMMANAGEMENT_TEXT" />,
  path: (tenantName) => `/${tenantName}/organize/seriesManagement`,
  icon: SeriesManagementIcon,
  searchPlaceholder: "Search by Series name or Tag",
  columns: (
    handleDelete,
    handleEdit,
    handlePreview,
    handleUserStatus,
    navigate,
    // location,
    // params,
    tenantName
  ) => [
    {
      ID: 1,
      name: <FormattedMessage id="NAME_TEXT" />,
      fieldName: "Name",
      value: (row) => (
        <div
          title={row?.Name?.length > 30 && row?.Name}
          style={{
            display: "flex",
            alignItems: "center",
            // justifyContent: "space-between",
          }}
        >
          {row?.Name?.length > 30 ? row?.Name?.slice(0, 30) + "..." : row?.Name}
          {row?.Status ? (
            <Tooltip
              content={<FormattedMessage id="DISTRIBUTED" />}
              direction={"bottom"}
            >
              <DistributeIcon width="25" height="25" />
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="CREATED_ON_TXT" />,
      fieldName: "CreatedDate",
      value: (row) => row.CreatedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: <FormattedMessage id="CREATED_BY" />,
      fieldName: "Creator",
      value: (row) => row?.Creator,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "",
      value: (row) => {
        return (
          <ToggleButton
            enable={row?.checked}
            leftText=" "
            rightText=" "
            isRed
            handleClick={(e) => handleUserStatus(e, row)}
          />
        );
      },
      sort: false,
    },
    {
      ID: 5,
      name: <FormattedMessage id="RECALL_ACTION" />,
      fieldName: "",
      value: (row) => (
        <>
          {row.PublishedbyMe === true && (
            <>
              <Tooltip
                content={<FormattedMessage id="MYCLASS_DELETE" />}
                direction={"bottom"}
              >
                <span onClick={() => handleDelete(row)}>
                  <DeleteIcon />
                </span>
              </Tooltip>
              <Tooltip
                content={<FormattedMessage id="MYCLASS_EDIT" />}
                direction={"bottom"}
              >
                <span
                  onClick={() =>
                    navigate(`${addSeriesMgmt.editpath(tenantName)}/${row.ID}`)
                  }
                >
                  <EditIcon />
                </span>
              </Tooltip>
            </>
          )}
          <Tooltip
            content={<FormattedMessage id="MYCLASS_COPY" />}
            direction={"bottom"}
          >
            <span
              onClick={() =>
                navigate(`${addSeriesMgmt.copypath(tenantName)}/${row.ID}`)
              }
            >
              <CopyIcon />
            </span>
          </Tooltip>
          <Tooltip
            content={<FormattedMessage id="P_REVIEW" />}
            direction={"bottom"}
          >
            <span
              onClick={() =>
                handlePreview(row.ID, row.Creator, row.CreatedDate)
              }
            >
              <ViewIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
